module.exports = __webpack_public_path__ + "static/img/brief_3.b24f052.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/brief_3.jpg
// module id = CCTG
// module chunks = 1